// extracted by mini-css-extract-plugin
module.exports = {"container":"PrivacyBanner_container__t3Fkx","content":"PrivacyBanner_content__2UtIC","button":"PrivacyBanner_button__FNr_G"};